import {
  Box,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { ContentCopy, CheckCircleOutline, Close } from '@mui/icons-material';
import { StyledModal, ModalContent } from '@/constants/themes';
import { useState } from 'react';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  sessionId: string;
}

const ShareModal: React.FC<ShareModalProps> = ({
  open,
  onClose,
  sessionId,
}) => {
  const theme = useTheme();
  const [copied, setCopied] = useState(false);
  const shareUrl = `${window.location.origin}/share/${sessionId}`;

  const handleCopy = async (text: string) => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalContent
        sx={{
          maxWidth: '600px',
          width: '90%',
          p: 4,
          gap: 3,
          backgroundColor:
            theme.palette.mode === 'dark'
              ? '#18181b'
              : theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: 2,
          boxShadow: theme.shadows[24],
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.text.secondary,
            '&:hover': {
              backgroundColor:
                theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.08)'
                  : 'rgba(0, 0, 0, 0.04)',
            },
            borderRadius: '50%',
          }}
        >
          <Close />
        </IconButton>

        <Typography variant="h5" gutterBottom sx={{ pr: 4 }}>
          Share Conversation
        </Typography>

        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Share Link
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              fullWidth
              value={shareUrl}
              size="medium"
              InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor:
                    theme.palette.mode === 'dark'
                      ? '#27272a'
                      : theme.palette.background.default,
                },
              }}
            />
            <Tooltip title={copied ? 'Copied!' : 'Copy link'}>
              <IconButton
                onClick={() => handleCopy(shareUrl)}
                size="medium"
                sx={{
                  color: theme.palette.primary.main,
                  borderRadius: '50%',
                  width: 40,
                  height: 40,
                  '&:hover': {
                    backgroundColor:
                      theme.palette.mode === 'dark'
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                {copied ? (
                  <CheckCircleOutline color="success" />
                ) : (
                  <ContentCopy />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </ModalContent>
    </StyledModal>
  );
};

export default ShareModal;
